/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import {
  InputV2,
  DialogDefaultV2,
  UsuarioSelectV2,
  EquipamentoSelectV2,
  DatePickerV2,
  DefaultSelectV2,
  ArquivoContainerV2,
} from '../../../components/v2';
import * as Roles from '../../../constants/role';
import * as actionsPedidoVoo from '../../../store/pedidoVoo/actions';
import * as selectorsPedidoVoo from '../../../store/pedidoVoo/reducer';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsModuleConfiguration from 'store/moduleConfiguration/reducer';
import { PEDIDO_VOO_ADMIN } from 'constants/modules';
import {
  PEDIDO_VOO_STATUS_OPTIONS,
  getCodigoPilotoSisant,
} from './statusLabels';
const schema = {
  inspetorId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  droneId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  data: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  cidade: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  latitude: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  longitude: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};
const getDefaultValues = () => ({
  status: 'AGUARDANDO_VALIDACAO',
  data: moment().valueOf(),
  arquivos: [],
});
const Formulario = ({
  open,
  id,
  onClose,
  onReload,
  authData,
  selectedPedidoVoo,
  savePedidoVoo,
  updatePedidoVoo,
  findPedidoVooById,
  validatePedidoVoo,
  pedidoVooClearSelected,
  moduleConfigurations,
}) => {
  const hasFullAccess = useMemo(
    () =>
      !!moduleConfigurations?.some(
        u => u.codigo === PEDIDO_VOO_ADMIN && u.userId === authData?.id
      ),
    [moduleConfigurations, authData]
  );
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [openNegar, setOpenNegar] = useState(false);
  const [motivoNegar, setMotivoNegar] = useState('');
  const [motivoError, setMotivoError] = useState(false);
  const [arquivosNegar, setArquivosNegar] = useState([]);
  const [adminEditMode, setAdminEditMode] = useState(false);
  const isFormReadOnly = () => {
    if (adminEditMode) return false;
    if (!hasFullAccess) {
      if (!id) return false;
      return values.status !== 'AGUARDANDO_VALIDACAO';
    }
    if (!id) return false;
    if (values.status === 'AGUARDANDO_VALIDACAO') return false;
    return true;
  };
  const isFieldDisabled = () => {
    if (adminEditMode) return false;
    if (!hasFullAccess) {
      if (!id) return false;
      return values.status !== 'AGUARDANDO_VALIDACAO';
    }
    if (!id) return false;
    return true;
  };
  const canAdminAttachOnDeny = () =>
    hasFullAccess && !!values.id && values.status === 'AGUARDANDO_VALIDACAO';
  const isArquivosDisabled = () => {
    if (canAdminAttachOnDeny()) return false;
    return isFieldDisabled();
  };
  useEffect(() => {
    if (open) {
      setAdminEditMode(false);
    }
  }, [open, id]);
  useEffect(() => {
    if (open && !id) {
      setValues({
        ...getDefaultValues(),
        inspetorId: hasFullAccess ? null : authData.id,
      });
    } else if (open && id) {
      findPedidoVooById(id);
    }
  }, [id, open, findPedidoVooById]);
  useEffect(() => {
    if (selectedPedidoVoo && selectedPedidoVoo.id) {
      setValues({
        ...selectedPedidoVoo,
        data: moment(selectedPedidoVoo.data, 'YYYY-MM-DD').valueOf(),
        arquivos: selectedPedidoVoo.arquivos || [],
      });
    }
  }, [selectedPedidoVoo]);
  const buildPayload = () => ({
    id: values.id || null,
    latitude: values.latitude,
    longitude: values.longitude,
    data: values.data ? moment(Number(values.data)).format('YYYY-MM-DD') : null,
    cidade: values.cidade,
    inspetorId: values.inspetorId,
    droneId: values.droneId,
    protocoloAnac: values.protocoloAnac || null,
    arquivos: values.arquivos || [],
  });
  const onCloseLocal = (isSave) => {
    pedidoVooClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    setAdminEditMode(false);
    setMotivoNegar('');
    setMotivoError(false);
    setArquivosNegar([]);
    onClose(isSave);
  };
  const onSave = () => {
    const erros = validate(buildPayload(), schema);
    setErrors(erros || {});
    if (!erros) {
      const payload = buildPayload();
      const callback = (ok) => {
        if (ok) onCloseLocal(true);
      };
      if (values.id) {
        updatePedidoVoo(values.id, payload, callback);
      } else {
        savePedidoVoo(payload, callback);
      }
    }
  };
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };
  const handleNegarConfirm = () => {
    if (!motivoNegar || !motivoNegar.trim()) {
      setMotivoError(true);
      return;
    }
    setOpenNegar(false);
    validatePedidoVoo(
      values.id,
      {
        status: 'INVALIDADO',
        motivoRestricao: motivoNegar,
        protocoloAnac: values.protocoloAnac || null,
        arquivos: arquivosNegar,
      },
      (ok) => {
        if (ok) {
          onReload && onReload();
          onCloseLocal(true);
        }
      }
    );
  };
  const canApprove = () => hasFullAccess && !!values.id && values.status === 'AGUARDANDO_VALIDACAO';
  const codigoPilotoSisant = getCodigoPilotoSisant(values);
  return (
    <>
      <DialogDefaultV2
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Pedido de Voo"
        confirmMessage="Salvar"
        maxWidth="md"
        fullWidth
        readOnly={isFormReadOnly()}
        headerAction={[
          {
            onClick: () => {
              setArquivosNegar([]);
              setMotivoNegar('');
              setMotivoError(false);
              setOpenNegar(true);
            },
            title: 'Negar',
            show: canApprove(),
          },
          {
            onClick: () => setAdminEditMode(true),
            title: 'Editar',
            show:
              !!hasFullAccess &&
              !!id &&
              values.status !== 'AGUARDANDO_VALIDACAO' &&
              !adminEditMode,
          },
        ]}
      >
        <Grid container spacing={1} sx={{ mt: 0 }}>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <DatePickerV2
              label="Data"
              isRequired
              error={!!(errors && errors.data)}
              value={values.data}
              disabled={isFieldDisabled()}
              onChange={(data) =>
                setValues({ ...values, data: data != null ? data : null })
              }
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
            <UsuarioSelectV2
              label="Inspetor"
              ativo
              grupos={[Roles.ADMIN, Roles.INSPETOR]}
              value={values.inspetorId}
              isRequired
              error={!!(errors && errors.inspetorId)}
              disabled={!hasFullAccess || (!!id && !adminEditMode)}
              onSelect={(inspetorId) => setValues({ ...values, inspetorId })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <InputV2
              label="Código SISANT"
              name="codigoPilotoSisant"
              value={codigoPilotoSisant || '—'}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 9 }} sx={{ pb: 0 }}>
            <EquipamentoSelectV2
              label="Drone"
              tipoEquipamento="DRONE"
              filterUsuarioUltimoRepasse={!hasFullAccess}
              value={values.droneId}
              isRequired
              error={!!(errors && errors.droneId)}
              disabled={isFieldDisabled()}
              onSelect={(droneId) => setValues({ ...values, droneId })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <DefaultSelectV2
              label="Status"
              name="status"
              options={PEDIDO_VOO_STATUS_OPTIONS}
              onSelect={() => {}}
              value={values.status || 'AGUARDANDO_VALIDACAO'}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
            <InputV2
              isRequired
              error={!!(errors && errors.cidade)}
              label="Cidade"
              name="cidade"
              value={values.cidade || ''}
              onChange={handleChange}
              disabled={isFieldDisabled()}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <InputV2
              isRequired
              error={!!(errors && errors.latitude)}
              label="Latitude"
              name="latitude"
              value={values.latitude || ''}
              onChange={handleChange}
              disabled={isFieldDisabled()}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
            <InputV2
              isRequired
              error={!!(errors && errors.longitude)}
              label="Longitude"
              name="longitude"
              value={values.longitude || ''}
              onChange={handleChange}
              disabled={isFieldDisabled()}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 8 }} sx={{ pb: 0 }}>
            <InputV2
              label="Protocolo ANAC"
              name="protocoloAnac"
              value={values.protocoloAnac || ''}
              onChange={handleChange}
              disabled={
                !hasFullAccess ||
                (!adminEditMode && values.status !== 'AGUARDANDO_VALIDACAO')
              }
            />
            {canApprove() && (
              <Typography variant="caption" color="primary" sx={{ mt: 0.5, display: 'block' }}>
                Ao informar o Protocolo ANAC e salvar, o pedido de voo será automaticamente aprovado.
              </Typography>
            )}
          </Grid>
          {values.status === 'INVALIDADO' && values.motivoRestricao && (
            <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
              <InputV2
                label="Motivo da Negação"
                value={values.motivoRestricao}
                multiline
                rows={3}
                disabled
              />
            </Grid>
          )}
          <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
            <ArquivoContainerV2
              arquivos={values.arquivos || []}
              disabled={isArquivosDisabled()}
              onSave={(arquivos) => setValues({ ...values, arquivos })}
            />
          </Grid>
        </Grid>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={openNegar}
        useFullScreen={false}
        handlerCancel={() => {
          setOpenNegar(false);
          setMotivoNegar('');
          setMotivoError(false);
          setArquivosNegar([]);
        }}
        handlerConfirm={handleNegarConfirm}
        title="Negar Pedido de Voo"
        confirmMessage="Confirmar"
        cancelMessage="Cancelar"
        maxWidth="sm"
        fullWidth
      >
        <Grid container spacing={1}>
          <Grid size={{ xs: 12 }}>
            <InputV2
              label="Motivo"
              value={motivoNegar}
              onChange={(e) => {
                setMotivoNegar(e.target.value);
                if (e.target.value && e.target.value.trim()) setMotivoError(false);
              }}
              multiline
              rows={3}
              isRequired
              error={motivoError}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <ArquivoContainerV2
              arquivos={arquivosNegar}
              disabled={false}
              onSave={setArquivosNegar}
            />
          </Grid>
        </Grid>
      </DialogDefaultV2>
    </>
  );
};
Formulario.propTypes = {
  savePedidoVoo: PropTypes.func.isRequired,
  updatePedidoVoo: PropTypes.func.isRequired,
  findPedidoVooById: PropTypes.func.isRequired,
  validatePedidoVoo: PropTypes.func.isRequired,
  pedidoVooClearSelected: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onReload: PropTypes.func,
  authData: PropTypes.object,
  selectedPedidoVoo: PropTypes.object,
  moduleConfigurations: PropTypes.array,
};
Formulario.defaultProps = {
  id: null,
  onReload: () => {},
  moduleConfigurations: [],
};
const mapStateToProps = (state) => ({
  selectedPedidoVoo: selectorsPedidoVoo.getSelectedPedidoVoo(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
  authData: selectorsAuth.getAuth(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsPedidoVoo,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
